import type { AnalyticsParams } from "api-contracts/rpc/analytics.ts";
import { queryOptions } from "ui-common/query-options";
import { rpc } from "ui-common/services/rpc";

export const analyticsDataQueryOptions = ({ startDate, endDate, filter }: AnalyticsParams) =>
  queryOptions({
    queryKey: ["analytics"],
    queryFn: () =>
      rpc("analytics", {
        startDate,
        endDate,
        filter,
      }),
  });
